import { z } from 'zod'

export const CRM_EMAIL_ATTACH_WRITE_CONTRACT_VERSION = '1.0.0' as const

export const crmEmailAttachFileResponseSchema = z.object({
  contract_version: z.literal(CRM_EMAIL_ATTACH_WRITE_CONTRACT_VERSION),
  fileId: z.string().min(1),
  outcome: z.enum(['created', 'reused', 'restored']),
  replayed: z.boolean(),
  sideEffects: z.record(z.unknown()),
}).passthrough()

export type CrmEmailAttachFileResponse = z.infer<typeof crmEmailAttachFileResponseSchema>
